import React from "react";

const LoadingSpinner = ({ message = "Verifying..." }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-xl px-8 py-6 flex flex-col items-center space-y-4 animate-fadeIn">
        <div className="bg-gray-100 p-4 rounded-full">
          <svg
            className="animate-spin h-10 w-10 text-indigo-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
        </div>
        <span className="text-lg font-medium text-gray-800 tracking-wide animate-pulse">
          {message}
        </span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
